// extracted by mini-css-extract-plugin
module.exports = {"faq":"xv_xw","question":"xv_qz","answer":"xv_q0","askQuestionContainer":"xv_xx","helpCenterLink":"xv_xy","helpCenterLinkfocus":"xv_xz","label":"xv_mo"};